<template>
  <div class="vet-prescription-info" v-if="vetPrescriptionInfo">
    <div class="vet-prescription-title">编号: {{ vetPrescriptionInfo.guid }}</div>
    <div v-if="vetPrescriptionInfo.createTime > 0">
      创建时间:
      <span>
        {{ new Date(vetPrescriptionInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
      </span>
    </div>
    <div>
      销售单号:
      <span>
        {{ vetPrescriptionInfo.orderGuid }}
      </span>
    </div>
    <div v-if="!!vetPrescriptionInfo.consumeName || !!vetPrescriptionInfo.consumePhone">
      动物主人:
      <span>
        {{
          [vetPrescriptionInfo.consumeName, vetPrescriptionInfo.consumePhone]
            .filter((item) => !!item)
            .join(", ")
        }}
      </span>
    </div>
    <div
      v-if="
        !!vetPrescriptionInfo.petType ||
        !!vetPrescriptionInfo.petGender ||
        !!vetPrescriptionInfo.petAge ||
        !!vetPrescriptionInfo.petWeight
      "
    >
      动物信息:
      <span>
        {{
          [
            vetPrescriptionInfo.petType,
            vetPrescriptionInfo.petGender,
            vetPrescriptionInfo.petAge,
            vetPrescriptionInfo.petWeight,
          ]
            .filter((item) => !!item)
            .join(", ")
        }}
      </span>
    </div>
    <div v-if="vetPrescriptionInfo.symptomList">
      主诉症状:
      <span> {{ vetPrescriptionInfo.symptomList }} </span>
    </div>
    <div v-if="vetPrescriptionInfo.diseaseList">
      诊断信息:
      <span> 疑似{{ vetPrescriptionInfo.diseaseList }} </span>
    </div>
    <div v-if="vetPrescriptionInfo.handledBy">
      操作人员:
      <span>
        {{ vetPrescriptionInfo.handledBy }}
      </span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.vet-prescription-info {
  line-height: 26px;
  font-size: 14px;
}

.vet-prescription-title {
  font-size: 16px;
  font-weight: bolder;
  line-height: 35px;
}

.vet-prescription-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.vet-prescription-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #5c5c5c;
  color: #5c5c5c;

  &.finish {
    background-color: #b24eff;
    border: 1px solid #b24eff;
    color: #ffffff;
  }

  &.closed {
    background-color: #333333;
    border: 1px solid #333333;
    color: #ffffff;
  }
}
</style>

<script>
export default {
  props: {
    vetPrescriptionInfo: {
      type: Object,
    },
  },
  methods: {
    getGoodsCount(skuGuid, status) {
      let count = 0;
      if (this.vetPrescriptionInfo) {
        if (this.vetPrescriptionInfo.status == status) {
          (this.vetPrescriptionInfo.itemList || []).forEach((goods) => {
            if (goods.skuGuid == skuGuid) {
              count += goods.goodsCount;
            }
          });
        }
      }
      return count;
    },
  },
  computed: {
    orderGoodsList() {
      let goodsList = [];
      let skuGuids = [];
      if (this.vetPrescriptionInfo) {
        (this.vetPrescriptionInfo.itemList || []).forEach((goods) => {
          if (skuGuids.indexOf(goods.skuGuid) < 0) {
            goodsList.push(goods);
            skuGuids.push(goods.skuGuid);
          }
        });
      }
      return goodsList;
    },
    statusClassName() {
      if (!this.vetPrescriptionInfo) {
        return "";
      }
      if (this.vetPrescriptionInfo.optStatus == 0) {
        return "vet-prescription-status none";
      } else if (this.vetPrescriptionInfo.optStatus == 1) {
        return "vet-prescription-status finish";
      } else if (this.vetPrescriptionInfo.optStatus == 2) {
        return "vet-prescription-status closed";
      }
      return "";
    },
    statusLabel() {
      if (!this.vetPrescriptionInfo) {
        return "";
      }
      if (this.vetPrescriptionInfo.optStatus == 0) {
        return "待开具";
      } else if (this.vetPrescriptionInfo.optStatus == 1) {
        return "已开具";
      } else if (this.vetPrescriptionInfo.optStatus == 2) {
        return "已关闭";
      }
      return "-";
    },
  },
};
</script>
